import React, { memo } from 'react'
import { array } from 'prop-types'
import serverData from '../utils/server-data'
import { Col, HeadingText, Badge } from '@paypalcorp/pp-react'
import SubSections from './SubSections'

const Sections = memo((props) =>
  props.sections.map(
    ({
      sectionId,
      sectionName,
      hasElmoTreatment,
      badge = {},
      subSections = [],
      isEnabled,
    }) =>
      isEnabled &&
      hasElmoTreatment &&
      (serverData.isMerchantUser ? (
        <div
          className="merchant-section-container"
          key={sectionName}
          id={sectionId}
        >
          <Col>
            <HeadingText
              id={`${sectionId}Header`}
              size="sm"
              className="merchant-section-header"
            >
              {sectionName}
            </HeadingText>
            <SubSections subSections={subSections} {...props} />
          </Col>
        </div>
      ) : (
        <div className="section-container" key={sectionName} id={sectionId}>
          <Col lg={12}>
            <HeadingText
              id={`${sectionId}Header`}
              size="lg"
              className="section-header"
            >
              {sectionName}
              {badge.type && (
                <Badge type={badge.type} className="section-badge">
                  {badge.text}
                </Badge>
              )}
            </HeadingText>
            <SubSections subSections={subSections} {...props} />
          </Col>
        </div>
      )),
  ),
)

Sections.propTypes = {
  sections: array,
}

Sections.defaultProps = {
  sections: [],
}

Sections.displayName = 'Sections'

export default Sections
